import React from "react"

import { Button } from "./styles"

const Contact = ({ onClick }) => <Button onClick={onClick}>Speak with us</Button>

export default Contact
